import { FeedApi } from '@sportheroes/oly-engine-api';

import { olyEngineApi } from './Config/olyEngineApi';

const { FEED_API_URL } = process.env;

export default new FeedApi(FEED_API_URL, {}, olyEngineApi);
